var React = require('react');

function Enter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 3C10.8954 3 10 3.89543 10 5V8H4C2.89543 8 2 8.89543 2 10V14C2 14.5523 2.44772 15 3 15C3.55228 15 4 14.5523 4 14V10H10C11.1046 10 12 9.10457 12 8V5H18C18.5523 5 19 4.55228 19 4C19 3.44772 18.5523 3 18 3H12Z","key":0}),React.createElement("path",{"d":"M22 9C22 8.44772 21.5523 8 21 8C20.4477 8 20 8.44772 20 9V16H10.4142L11.7071 14.7071C12.0977 14.3166 12.0977 13.6834 11.7071 13.2929C11.3166 12.9024 10.6834 12.9024 10.2929 13.2929L7.29292 16.2929C6.9024 16.6834 6.9024 17.3166 7.29292 17.7071L10.2929 20.7071C10.6834 21.0976 11.3166 21.0976 11.7071 20.7071C12.0977 20.3166 12.0977 19.6834 11.7071 19.2929L10.4142 18H20C21.1046 18 22 17.1046 22 16V9Z","key":1})]);
}

Enter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Enter;

Enter.default = Enter;
